import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import type { useLabelPinWorkspace } from "../useLabelPinWorkspace";
import { LabelPinField } from "./LabelPinField";

export function LabelPinForm({ workspace }: { workspace: ReturnType<typeof useLabelPinWorkspace> }) {
  const [help, setHelp] = useState(false);
  const heading = useRef<HTMLHeadingElement>(null);
  const previousHelp = useRef(help);
  useEffect(() => {
    if (previousHelp.current !== help) heading.current?.focus();
    previousHelp.current = help;
  }, [help]);
  function showHelp(value: typeof help) {
    workspace.setPin(""); workspace.clearError();
    setHelp(value);
  }
  const title = help ? "PIN’ini yeniden al" : "Etiket hesabına giriş yap";
  return <section className="anl-label-access" aria-labelledby="label-pin-title">
    <header className="anl-access-header">
      <div className="anl-access-brand"><img src="/anl-logo-new-2026.webp" alt="ANL" width={36} height={36} />
        <div><strong>ANL Platform</strong><span>Etiket çalışma alanı</span></div></div>
      <a href="/">Kurumsal girişe dön</a>
    </header>
    <div className="anl-access-body">
      <div className="anl-access-panel">
        <h1 id="label-pin-title" ref={heading} tabIndex={-1}>{title}</h1>
        {help ? <>
          <p className="anl-access-intro">PIN’ini yeniden almak veya değiştirmek için sistem yöneticine başvur.</p>
          <div className="anl-access-help">
            <p>Sistem yöneticisi sana yeni 4 haneli PIN belirleyebilir. PIN sözlü olarak verilebilir veya istenirse e-postayla iletilebilir.</p>
          </div>
          <button type="button" className="anl-access-primary" onClick={() => showHelp(false)}>Girişe dön</button>
        </> : <>
          <p className="anl-access-intro">Sistem yöneticinin verdiği 4 haneli PIN ile devam et.</p>
          <form onSubmit={event => { event.preventDefault(); void workspace.submit(); }} aria-busy={workspace.busy}>
            <fieldset disabled={workspace.busy}>
              <legend className="anl-visually-hidden">PIN girişi</legend>
              <LabelPinField id="label-login-pin" label="Kişisel PIN" value={workspace.pin} onChange={workspace.setPin}
                error={Boolean(workspace.error)} hint="Sana verilen 4 haneli PIN’i gir." />
              <div className="anl-access-options"><button type="button" onClick={() => showHelp(true)}>PIN’imi unuttum</button></div>
              {workspace.error ? <p id="label-pin-error" className="anl-access-error" role="alert">{workspace.error}</p> : null}
              <button type="submit" className="anl-access-primary">{workspace.busy ? "Doğrulanıyor…" : "Giriş yap"}<ArrowRight size={18} aria-hidden="true" /></button>
            </fieldset>
          </form>
        </>}
      </div>
    </div>
  </section>;
}
